var myEvents;
(function (myEvents) {
    document.addEventListener('ControllerReady', () => {
        const config = retrieveConfig(document);
        const configGet = retrieveConfigGet(document);
        let divInit = document.querySelector('.myevents-init'); 
        let divEvent = document.querySelector('.myevents-div'); 
        let getServiceEndpoint = `${config.url}` + `${config.config['url_my_events']}` + '?jsonFormat&';
        const ServicesEndpointPro = `/api/esb/user/getProfile?_format=form`;
        let sectionUe = document.querySelector('.user-engagement-container');
        let logout = document.querySelector('#btn-logout-left');
        logout === null || logout === void 0 ? void 0 : logout.addEventListener('click', logOut);
        if (getCookie('session_token') == '' || getCookie('session_coopId') == '') {
            window.location.href = '/auth/login';
        }
        getProfile();
        init();
        function init() {
            var _a, _b, _c, _d;
            (_a = document.querySelector('#myevents-left-menu')) === null || _a === void 0 ? void 0 : _a.classList.add('left-menu-selected');
            (_b = document.querySelector('#myprofile-left-menu')) === null || _b === void 0 ? void 0 : _b.classList.remove('left-menu-selected');
            (_c = document.querySelector('.my-events-margin-left')) === null || _c === void 0 ? void 0 : _c.classList.add('margin-left-selected');
            (_d = document
                .querySelector('.profile-margin-left')) === null || _d === void 0 ? void 0 : _d.classList.remove('margin-left-selected');
        }
        function kettyDo() {
            Fetch(getServiceEndpoint + window.location.search.replace('?', ''), {
                method: 'GET',
                credentials: 'omit',
            })
                .then((response) => {
                if (response.status == 'OK') {
                    loadKettydoSite(response, 'user-engagement-container');
                }
                else {
                    console.log('result: ', response.status);
                    console.log('result message: ', response.message);
                }
                divInit === null || divInit === void 0 ? void 0 : divInit.classList.add('hidden');
                divEvent === null || divEvent === void 0 ? void 0 : divEvent.classList.remove('hidden');
            })
                .catch((err) => {
                console.error('Error: ', err);
                divInit === null || divInit === void 0 ? void 0 : divInit.classList.add('hidden');
                divEvent === null || divEvent === void 0 ? void 0 : divEvent.classList.remove('hidden');
            });
        }
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function retrieveConfigGet($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config-get');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url-get"]').value;
                    const config = $form.querySelector('[name="config-get"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function getProfile() {
            var url = {
                token: getCookie('session_token'),
                email: getCookie('session_email'),
                coopId: getCookie('session_coopId'),
            };
            Fetch(ServicesEndpointPro, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    getServiceEndpoint +=
                        'coopId=' +
                            response.payload.profile.coopId +
                            '&pdv=' +
                            response.payload.profile.pdv +
                            '&email=' +
                            response.payload.profile.email +
                            '&userIdCoop' +
                            response.payload.profile.userIdCoop +
                            '&name=' +
                            response.payload.profile.name +
                            '&surname=' +
                            response.payload.profile.surname +
                            '&birthdate=' +
                            response.payload.profile.birthdate +
                            '&token=' +
                            getCookie('session_token') +
                            '&';
                }
                kettyDo();
            })
                .catch((err) => {
                console.error('Error: ', err);
                divInit === null || divInit === void 0 ? void 0 : divInit.classList.add('hidden');
                divEvent === null || divEvent === void 0 ? void 0 : divEvent.classList.remove('hidden');
            });
        }
        function logOut() {
            delete_cookie('session_token');
            delete_cookie('session_email');
            delete_cookie('session_coopId');
            delete_cookie('session_info');
            delete_cookie('event_info');
            delete_cookie('aperitivo');
            if (window.location.pathname == '/area-riservata/i-miei-eventi')
                window.location.href = '/auth/login';
        }
        function delete_cookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
    });
})(myEvents || (myEvents = {}));
